/**
 * @title Get Elements that Start with ID
 * @description Retrieve elements from the DOM that ID's partially match the start of the given ID.
 * @param {string} id
 */
export default function getElementsStartWithId(id) {
  let children = document.body.getElementsByTagName("*")
  let elements = []
  let child = null

  for (var i = 0, length = children.length; i < length; i++) {
    child = children[i]
    if (child.id.substr(0, id.length) == id) elements.push(child)
  }
  return elements
}
